import React from 'react';

const Profile = ({ match }) => {
    return (
        <div>
            <h1>{ match.params.name }'s Profile</h1>
        </div>
    )
}

export default Profile;